<template>
  <div class="project-preview">
    <HeroSection :project="project" />
    <div class="container">
      <Breadcrumb :breadcrumb="projectBreadcrumb" class="projects-breadcrumb" />
      <Description :project="project" />
    </div>
    <div v-if="project.otherProjects.length" class="other-projects">
      <div class="container">
        <Slider
          class="slider"
          :disabled="project.otherProjects.length <= 3"
        >
          <h1 slot="heading" class="title">
            Other projects
          </h1>
          <nuxt-link slot="controls" to="/projects/">
            Show All
          </nuxt-link>
          <Card
            v-for="(p, id) in project.otherProjects"
            :key="id"
            slot="slide"
            :project="p"
            heading="h6"
            class="col-4 sm-6"
            dark
          />
        </Slider>
      </div>
    </div>
  </div>
</template>

<script>
import HeroSection from '@itbpbg/lms-components/src/Projects/HeroSection.vue';
import Description from '@itbpbg/lms-components/src/Projects/Description.vue';
import Breadcrumb from '@itbpbg/lms-components/src/components/Breadcrumb';
import Slider from '@itbpbg/lms-components/src/components/Slider';
import Card from '@itbpbg/lms-components/src/Projects/Card';

import global from '@itbpbg/lms-components/src/mixins/global';

export default {
  components: {
    HeroSection, Description, Breadcrumb, Slider, Card,
  },
  mixins: [global],

  async asyncData({ $axios, route, error }) {
    const project = await $axios.$get(`/projects/${route.params.slug}?origin=site`).catch(() => false);
    if (!project) {
      return error({ statusCode: 404, message: 'Page not found' });
    }

    return { project };
  },

  head() {
    return {
      titleTemplate: `${this.project.metaTitle} %s`,
      meta: this.metaProps(this.project),
    };
  },

  computed: {
    projectBreadcrumb() {
      return [
        {
          slug: '/projects/',
          name: 'Projects',
        },
        {
          slug: '',
          name: this.project.title,
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.project-preview {
  background: var(--main-light-shade-1);

  .projects-breadcrumb {
    margin: var(--spacing-48) 0;

    ul li span {
      color: var(--main-dark-light-4);
    }
  }

  .btn-lg {
    width: 300px;
  }

  .other-projects {
    background: var(--main-dark-light-1);
    padding: 130px 0 110px;

    .project-card .card-body {
      min-height: 329px;

      .card-footer {
        .title {
          line-height: 110%;
        }

        p {
          line-height: 130%;
        }
      }
    }

    .title {
      margin-bottom: 0;
      font-size: 28px;
      font-weight: 500;
      line-height: 110%;
      color: var(--main-light);
    }

    ::v-deep {
      .slider-container .slider-header .controls svg {
        circle[fill] {
          fill: transparent;
        }

        circle[stroke] {
          stroke: var(--main-light);
        }

        path[stroke] {
          stroke: var(--main-light);
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .project-preview .btn-lg {
    width: 225px;
  }
}

@include bp($bp-mobile) {
  .project-preview {
    .other-projects {
      padding: var(--spacing-80) 0;

      ::v-deep {
        .slider-container .dots {
          padding: var(--spacing-16) 0 0 0;

          .dot {
            &:after {
              background: rgba(255, 255, 255, 0.48);
            }

            &.active:after {
              background: var(--main-light);
            }
          }
        }
      }
    }
  }
}

.fa {
  .project-preview {
    background: var(--main-light-shade-2);
  }
}
</style>
